<div class="nlc-admin-settings-card nlc-card nlc-fade-in">
  <div class="settings-header">
    <div class="settings-icon">
      <mat-icon>flash_on</mat-icon>
    </div>
    <div>
      <h2 class="nlc-heading-3">Admin Werkzeuge</h2>
      <p class=" nlc-body-secondary setting-text">
        Verwalte FAQs, Coin-Staffelungen und weitere Einstellungen.
      </p>
    </div>
  </div>

  <div class="settings-actions">
    @for (item of settingsActionButtons; track $index) {
      @if (item.link) {
        <a mat-flat-button [routerLink]="item.link" class="nlc-button nlc-button-primary nlc-button-large">
          <mat-icon>{{item.icon}}</mat-icon>
          {{item.text}}
        </a>
      } @else if (item.action) {
        <button mat-flat-button (click)="item.action()" class="nlc-button nlc-button-primary nlc-button-large">
          <mat-icon>{{item.icon}}</mat-icon>
          {{item.text}}
        </button>
      }
    }
  </div>
</div>
